import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.667 2.5a4.167 4.167 0 1 0 0 8.333 4.167 4.167 0 0 0 0-8.333M1.5 6.667a5.167 5.167 0 1 1 10.333 0 5.167 5.167 0 0 1-10.333 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.646 9.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSearch;
